var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgAi = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 14,
  fill: "none",
  viewBox: "0 0 19 14",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 0a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h11a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm4.289 5.865.88 2.405h-2.3l.875-2.395q.065-.165.135-.385.07-.225.135-.48.07.255.14.475t.135.38M10.504 11h1.04l-2.84-7.23h-1.37L4.489 11h1.05a.43.43 0 0 0 .285-.095.5.5 0 0 0 .155-.21l.54-1.475h2.995l.54 1.475q.056.13.165.22a.45.45 0 0 0 .285.085m1.788 0h1.35V3.77h-1.35z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAi);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };